import { Modal } from 'antd';

import styles from './stylesWithdrawalReview.module.css';

import { SIDER_TABS } from '../../../utils/Constants';
import Layout from '../../CommonComponents/Layout/Layout';
import TableTabs from './TableTabs/TableTabs';
import PendingRequestsTable from './PendingRequestsTable/PendingRequestsTable';
import ProcessedRequestsTable from './ProcessedRequestsTable/ProcessedRequestsTable';
import ReviewRulesLink from './ReviewRulesLink/ReviewRulesLink';
import CustomDatePicker from '../../CommonComponents/CustomDatePicker/CustomDatePicker';
import ViewDetailsModal from './ViewDetailsModal/ViewDetailsModal';
import DeclineRequestModal from './DeclineRequestModal/DeclineRequestModal';
import ExportToXlsxButton from '../../CommonComponents/ExportToXlsxButton/ExportToXlsxButton';

import {
  WithdrawalReviewProvider,
  useWithdrawalReview,
} from './WithdrawalReviewContext';

function WithdrawalReviewContent() {
  const {
    selectedTab,
    setSelectedTab,
    rangeDates,
    setRangeDates,
    isDeclineModalOpen,
    setIsDeclineModalOpen,
    isDetailsModalOpen,
    setIsDetailsModalOpen,
    pendingTransactions,
    processedTransactions,
  } = useWithdrawalReview();

  return (
    <Layout name={SIDER_TABS.TRANSACTIONS}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Withdrawal Review</h2>
          <div className={styles.headerOptions}>
            <ReviewRulesLink />
            <CustomDatePicker
              getData={() => {}}
              dates={rangeDates}
              setDates={setRangeDates}
              showQuickSelect={true}
              showPresets={true}
            />
            <div className={styles.exportButton}>
              <ExportToXlsxButton
                data={
                  selectedTab === 'PENDING'
                    ? pendingTransactions?.transactions
                    : processedTransactions?.transactions
                }
                filename={
                  selectedTab === 'PENDING'
                    ? 'pending-transactions'
                    : 'processed-transactions'
                }
              />
            </div>
          </div>
        </div>

        <TableTabs onSelectTab={setSelectedTab} />

        {selectedTab === 'PENDING' && <PendingRequestsTable />}
        {selectedTab === 'PROCESSED' && <ProcessedRequestsTable />}
      </div>

      <Modal
        closable={false}
        open={isDeclineModalOpen}
        onCancel={() => setIsDeclineModalOpen(false)}
        footer={null}
        width={400}
      >
        <DeclineRequestModal />
      </Modal>

      <Modal
        closable={false}
        open={isDetailsModalOpen}
        onCancel={() => setIsDetailsModalOpen(false)}
        footer={null}
        width={450}
        className={styles.detailsModal}
      >
        <ViewDetailsModal />
      </Modal>
    </Layout>
  );
}

export default function WithdrawalReview() {
  return (
    <WithdrawalReviewProvider>
      <WithdrawalReviewContent />
    </WithdrawalReviewProvider>
  );
}
